<template lang="pug">
  .popup-container(@click="close")
    .main(@click.prevent.stop)
      slot
      .safe-area

</template>

<script>

export default {
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>

.popup-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;

  .main {
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    border-radius: 0.08rem 0.08rem 0 0;
    text-align: center;
    padding: 0 0 0.2rem 0;

    .safe-area {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
